import React, { Component } from "react";

import vouchers from 'services/vouchers';

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Benefits/Campaign/components";

import swal from 'sweetalert';

class Create extends Component {
  state = {
    data: {
      title: "",
      description: "",
      status_value: true,
    },
    loading: false,
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Benefícios", to: "/benefits" },
      { name: "Campanhas Comerciais", to: "/benefits/campaign/list" },
      { name: "Adicionar Nova", to: "" },
    ],
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },
      description: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = async () => {
    if (!this.handleValidate()) return null;

    try {
      this.setState({ loading: true });
      const { data } = this.state;

      await vouchers.post("experience/commercial_campaigns", {
        title: data.title,
        description: data.description,
        status_value: data.status_value
      });

      swal('Sucesso', 'Campanha comercial criada com sucesso.', 'success')
      await this.props.history.push('/benefits/campaign/list')
    } catch (err) {
      swal('Falha ao criar', 'Não foi possível criar a campanha comercial.', 'error')
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { data, loading, errors, breadcrumbs } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

export default Create;
